export class AlreadyExistsError extends Error {
  constructor(
    public readonly message: string,
    public readonly existingId: number | string | undefined,
    public readonly additional?: { [p: string]: any }
  ) {
    super(message)
  }
}
